import { useTheme } from '@mui/material/styles';

export const Base = ({ color, ...props }) => {
    const theme = useTheme();
    const finalColor = color || theme.palette.figma.white[30];

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="42" viewBox="0 0 22 42" fill="none">
            <path d="M6 13.5H16L21 41.5M0 0.5H6V26.5H0" stroke={finalColor} strokeOpacity="1" />
        </svg>
    );
};

export const Win01 = ({ color, ...props }) => {
    const theme = useTheme();
    const finalColor = color || theme.palette.figma.buttonOrange;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="42" viewBox="0 0 22 42" fill="none">
            <path d="M0 0.5H6V13.5H16L21 41.5" stroke={finalColor} />
        </svg>
    );
};

export const Win02 = ({ color, ...props }) => {
    const theme = useTheme();
    const finalColor = color || theme.palette.figma.buttonOrange;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="30" viewBox="0 0 22 30" fill="none">
            <path d="M0 14H6V1H16L21 29" stroke={finalColor} />
        </svg>
    );
};